import { render, staticRenderFns } from "./residents.vue?vue&type=template&id=0237407a&"
import script from "./residents.vue?vue&type=script&lang=js&"
export * from "./residents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports